import axios from "axios";
import qs from "qs";
import { exerciseItem } from "../pages/CourseDetail/Store";

export enum ExerciseStatus {
    Idle = 0, //待参与
    Done = 1 //已参与
}

export const ExerciseStatusMap = {
    [ExerciseStatus.Idle]: "待参与",
    [ExerciseStatus.Done]: "已参与"
};

export interface ExerciseListItem {
    id: string;
    title: string;
    exercieStatus: string;
    startTime: string;
    endTime?: string;
    timeRang: string;
    status: string; //0未开始， 1进行中， 2已结束
}

export interface ExerciseItem {
    id: number;
    description: string;
    exerciseStatus: string; //0：未开始，1：进行中，2：已结束
    validityTime: any;
    weekTimeId: number;
    startTime: any;
    endTime: any;
    delStatus: number;
    createUser: number;
    updateUser: number;
    createTime: string;
    updateTime: string;
    exerciseCount: number;
    exerciseAllCount: number;
    judgeCount: number;
    noJoinInExerciseCount: number;
    noJudgeCount: number;

    studentExerciseStatus: string; //0 未参与， 1 已参与
    joinInExerciseCount: string;
    needJudgeCount: string;
    isHaveQuestion: string;
}

/**
 * 获取练习活动列表数据
 * @param courseId
 * @param courseNo
 * @param courseSeq
 * @param weekTimeId
 */
export function getExerciseList(
    courseId: string,
    courseNo: string,
    courseSeq: string,
    weekTimeId: number
) {
    return axios
        .post<SuccessData<ExerciseItem[]>>(
            `/student/exercise/getExerciseList`,
            qs.stringify({ courseId, courseNo, courseSeq, weekTimeId })
        )
        .then(data => data.data.data);
}

export interface PaperProps {
    unfinishedCount: string; // 学生未作答试题数
    topics: TopicsItem[];
    topicCount: string; //总题数
    totalScore: string; //总分

    stuDoFlg: string; // 学生试卷是否作答标识(是否提交了，1提交了0未提)
    stuPaperScore: string; // 学生试卷得分
    teacherFinishMark: string; //整张卷批卷状态（0未批，1已批）
    viewPaper: string; //判断活动结束（0未结束，1已结束）
}

export interface TopicsItem {
    index: number;
    score: string; //分值
    contentText: string; //标题
    id: string;
    sort: number;
    stuFinishTopic: string; //是否打完了0未答，1已答
    queTypeId: string; //queTypeId 1,2,3,4,5,6:阅读理解（6以上都有可能多题干）
    paperId: string;
    stuAns: string;
    typeName: string; //题类型名

    options: OptionItem[];
    questions: TopicsItem[];

    analysis: string; //（主观题）参考答案
    stuIsRight: string; //是否正确
    stuScore: string; //学生得分
    teacherMark: string; // 教师是否批阅 1:已批阅, 0:未批阅
    teacherComment: string; // 教师评语
    rightAnsText: string; //填空判断选择的正确答案（主观题取参考答案analysis）
    stuAnsText: string; //填空判断的学生答案（主关，填空直接取stuAns）
}

export interface OptionItem {
    isRight: string;
    questionId: string;
    description: string;
    id: string;
    value: string;

    isMatchCase: string; //区分全半角0,1
    isMatchSBCDBC: string; //区分大小写0,1
    isLoseSpace: string; //区分空格0不忽略,1忽略
}

/**
 * 获取试卷
 * @param exerciseId
 * @param view 传固定值1是查这个试卷答题情况详情
 */
export function getPaper(exerciseId: string, view?: string) {
    return axios
        .post<SuccessData<PaperProps>>(
            `/student/exercise/getPaper`,
            qs.stringify({ exerciseId, view })
        )
        .then(data => data.data.data)
        .then(data => ({
            unfinishedCount: data.unfinishedCount,
            topicCount: data.topicCount,
            totalScore: data.totalScore,
            topics: data.topics.map((item: TopicsItem, index: number) => ({
                ...item,
                index: index + 1
            })),
            stuDoFlg: data.stuDoFlg,
            stuPaperScore: data.stuPaperScore,
            teacherFinishMark: data.teacherFinishMark,
            viewPaper: data.viewPaper
        }));
}

/**
 * 单题保存
 * @param exerciseId paperId
 * @param trunkId 小题id
 * @param answer 分题型内容不同, 均为字符串。单选，判断时，值为选项id; 多选值为选项id数组; 填空题值为json格式{"optionId1":"studentAnswer1","optionId2":"studentAnswer2"} ; 主观题值为学员答案
 */
export function saveOne(exerciseId: string, trunkId: string, answer: string) {
    return axios
        .post(
            `/student/exercise/save`,
            qs.stringify({ exerciseId, trunkId, answer })
        )
        .then(data => data.data.data);
}

/**
 * 试卷提交
 * @param exerciseId 试卷id
 * @param paperAnswer 试卷全部答案， 格式为json, key为小题id, value为答案，答案格式跟单题保存格式相同
 * @param courseId 课程id
 */
export function questionSubmit(
    courseId: string,
    exerciseId: string,
    paperAnswer: string
) {
    return axios
        .post(
            `/student/exercise/submit`,
            qs.stringify({ courseId, exerciseId, paperAnswer })
        )
        .then(data => data.data.data);
}

//找到id下的value返显用
export function findOneValue(id: string, exercise: exerciseItem[]) {
    let answer = "";
    for (let item of exercise) {
        if (item.id === id && item.oneAnswer) {
            answer = item.oneAnswer;
            break;
        }
    }
    return answer;
}

export function findMoreValue(id: string, exercise: exerciseItem[]) {
    let answer;
    for (let item of exercise) {
        if (item.id === id && item.moreAnswer) {
            answer = item.moreAnswer;
            break;
        }
    }
    return answer;
}

/**
 * 获得未作答试题数
 * @param exerciseId
 */
export function checkSubmit(exerciseId: string) {
    return axios
        .post<SuccessData<number>>(
            `/student/exercise/checkSubmit`,
            qs.stringify({ exerciseId })
        )
        .then(data => data.data.data);
}

export interface ExerciseProps {
    validityTime: number;
    description: string;
    startTime: string;
    id: string;
    endTime: string;
    courseId: string;
}

/**
 * 获取单个练习
 * @param exerciseId
 */
export function getExercise(exerciseId: string) {
    return axios
        .post<SuccessData<ExerciseProps>>(
            `/student/exercise/getExercise`,
            qs.stringify({ exerciseId })
        )
        .then(data => data.data.data);
}

/**
 * 获取学生试卷状态（查练习活动详情头部信息）
 * @param exerciseId
 */
export function getPaperStatus(exerciseId: string) {
    return axios
        .post<SuccessData<ExerciseProps>>(
            `/student/exercise/getPaperStatus`,
            qs.stringify({ exerciseId })
        )
        .then(data => data.data.data);
}
